module.exports = __webpack_public_path__ + "img/logo.eb798b9a.svg";